export const pageNames = Object.freeze({
  // <---- Channel Steering Page Group ---->
  contactUsPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::contact-us:::',
    e: 'im',
    event_name: 'classic_help_contactus_page_shown',
  },
  contactUsPageContactOptions: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::contact-options:::',
    e: 'ac',
    event_name: 'classic_help_contactus_page_contact_option_shown',
  },
  contactUsPageUpfrontFAQ: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::upfront-faq:::',
    e: 'ac',
    event_name: 'classic_help_contactus_page_upfront_faq_shown',
  },
  contactUsPageSearchBox: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::intent-search:::',
    e: 'ac',
    event_name: 'classic_help_contactus_page_intent_search',
  },
  contactUsChatTimeoutPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::chat-timeout:::',
  },
  callUsPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::callus:::',
    e: 'im',
    event_name: 'classic_help_callus_page_shown',
  },
  // Call Us redesign page
  callPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::call:::',
    e: 'im',
    event_name: 'classic_help_callus_page_shown',
  },
  callPageInvalidTopicCode: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::call-invalid-topic-code:::',
  },
  emailPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::email:::',
    e: 'im',
    event_name: 'classic_help_email_page_shown',
  },
  emailByPassPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::emailByPass:::',
  },
  intermediatePage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::intermediate:::',
    e: 'im',
    event_name: 'classic_help_intermediate_page_shown',
  },
  chatBot: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::chatBot:::',
    e: 'ac',
    event_name: 'classic_help_chatbot_in_contactus_page_shown',
  },
  webPinNotApplicable: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::web-pin-not-applicable:::',
  },
  chatMessageUsChatBotLoadError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::chat-empty-channel:::',
  },
  // RAC
  requestACall: {
    // RAC inside call us
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::requestACall:::',
    e: 'ac',
    event_name: 'classic_help_rac_in_callus_page_shown',
  },
  requestACallError: {
    // RAC submit failed due to a reason
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::requestACallError:::',
    e: 'im',
    event_name: 'classic_help_rac_failure_in_callus_page_shown',
  },
  requestACallSuccess: {
    // RAC successfully submitted
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::requestACallSuccess:::',
    e: 'im',
    event_name: 'classic_help_rac_success_in_callus_page_shown',
  },

  // webPin Impression tracking
  webPinSuccess: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::web-pin:::',
    e: 'ac',
    event_name: 'classic_help_callus_page_webpin_shown',
  },

  webPinfailure: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::web-pin-error:::',
    e: 'ac',
    event_name: 'classic_help_callus_page_webpin_not_shown',
  },

  // <---- Error Pages ---->
  ErrorPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::error:::',
  },
  emailByPassPageError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::emailByPass-error:::',
  },
  chatBotArticleInEligible: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::smart-chatBotInEligible:::',
  },
  chatBotArticleError: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::chatBot-did-not-load-error:::',
  },
  chatBotContactUsError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::chatBot-did-not-load-error:::',
  },
  chatBotHomeError: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::chatBot-did-not-load-error:::',
  },
  contactLexaFailureError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::lexa-failure-intermediate:::',
  },
  articleLexaFailureError: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::lexa-failure-intermediate:::',
  },
  asyncContactUsError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::async-chat-did-not-load-error:::',
  },

  // <---- HCR Page Group ---->
  homePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::home:::',
    e: 'im',
    event_name: 'classic_help_home_page_shown',
  },
  PCCTrackingPage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::pcc:::',
    e: 'ac',
    event_name: 'classic_help_pcc_article_in_home_page_shown',
  },
  searchPage: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::search:::',
    e: 'im',
    event_name: 'classic_help_search_page_shown',
  },
  searchErrorPage: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::search-error:::',
    e: 'im',
    event_name: 'classic_help_search_error_page_shown',
  },
  articlePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::article:::',
    e: 'im',
    event_name: 'classic_help_article_page_shown',
  },
  articleErrorPage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::article-error:::',
    e: 'im',
    event_name: 'classic_help_article_error_page_shown',
  },
  currencyConverterArticle: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::currency-converter:::',
  },
  topicPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::topic:::',
    e: 'im',
    event_name: 'classic_help_topic_page_shown',
  },
  chatBotHome: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::chatBot:::',
    e: 'ac',
    event_name: 'classic_help_chatbot_in_home_page_shown',
  },
  chatBotArticle: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::chatBot:::',
    e: 'ac',
    event_name: 'classic_help_chatbot_in_article_page_shown',
  },
  topicErrorPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::topic-error:::',
    e: 'im',
    event_name: 'classic_help_topic_error_page_shown',
  },
  articleintermediatePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::intermediate:::',
    e: 'im',
    event_name: 'classic_help_intermediate_page_in_article_page_shown',
  },
  CC3TrackingPage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::cc3:::',
  },
  omniTrackingPage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::omni:::',
  },
  // <!-- Step-up -->
  stepUpIntermediatePage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::step-up-intermediate:::',
    e: 'im',
    event_name: 'classic_help_intermediate_page_stepUpFlow_shown',
  },
  stepUpIntermediatePage_anwFailure: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::step-up-intermediate-anwFailure:::',
    e: 'ac',
    event_name: 'classic_help_intermediate_page_stepup_anw_failure',
  },
  stepUpIntermediatePage_anwIgnoreDecisions: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::step-up-intermediate-IgnoreDecisions:::',
    e: 'ac',
    event_name: 'classic_help_intermediate_page_stepup_ignoreDecisions',
  },
  stepUpIntermediatePage_decision: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::step-up-intermediate-decisions:::',
    e: 'ac',
    event_name: 'classic_help_intermediate_page_stepup_decision',
  },
  stepUpIntermediatePage_no_translations: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::step-up-intermediate-no-translations:::',
    e: 'ac',
    event_name: 'classic_help_intermediate_page_stepup_no_translations',
  },
  stepUpIntermediatePage_riskFailure: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::step-up-intermediate-risk-failure:::',
    e: 'ac',
    event_name: 'classic_help_intermediate_page_stepup_risk_failure',
  },
  stepUpIntermediatePage_anw_service_failure: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::step-up-intermediate-anw-service-failure:::',
    e: 'ac',
    event_name: 'classic_help_intermediate_page_stepup_anw_service_failure',
  },
  confirmAuthPrompt: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::confirm-auth-prompt:::',
  },
  confirmAuthFailure: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::confirm-auth-failure:::',
  },

  // Dispute-Info
  disputeContactInfo: { // Dispute alert default tracking
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::dispute-status-info:::',
    e: 'ac',
    event_name: 'classic_help_dispute_alert_in_contactus_page_shown',
  },

  disputeSearchInfo: { // Dispute alert default tracking
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::dispute-status-info:::',
    e: 'ac',
    event_name: 'classic_help_dispute_alert_in_search_page_shown',
  },

  disputeTransactions: {
    pageGroupName: 'main:help:smart::transactions',
    pageName: 'main:help:smart::dispute-transactions:::',
    e: 'ac',
    event_name: 'classic_help_dispute_transactions_in_article_page_shown',
  },

  // ICF-Info

  ICFGuide: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::icf-guide:::',
    e: 'ac',
    event_name: 'classic_help_icf_guide_in_home_page_shown',
  },

  ICFL1Topic: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::icf:::',
    e: 'ac',
    event_name: 'classic_help_icf_guides_entry_in_L1_topic_in_home_page_shown',
  },

  ICFPage: {
    pageGroupName: 'main:help:smart::icf',
    pageName: 'main:help:smart::icf-articles:::',
    e: 'im',
    event_name: 'classic_help_icf_article_page_shown',
  },

  ICFPageError: {
    pageGroupName: 'main:help:smart::icf',
    pageName: 'main:help:smart::icf-articles-error:::',
    e: 'im',
    event_name: 'classic_help_icf_article_error_page_shown',
  },

  ICFTopic: {
    pageGroupName: 'main:help:smart::icf-topic',
    pageName: 'main:help:smart::icf-topic:::',
    e: 'im',
    event_name: 'classic_help_icf_topic_page_shown',
  },

  ICFTopicPageError: {
    pageGroupName: 'main:help:smart::icf-topic',
    pageName: 'main:help:smart::icf-topic-error:::',
    e: 'im',
    event_name: 'classic_help_icf_topic_error_page_shown',
  },

  // NAA Alert
  NAAContactUs: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::naa-alert:::',
    e: 'ac',
    event_name: 'classic_help_naa_alert_in_contactus_page_shown',
  },
  NAAHomePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::naa-alert:::',
    e: 'ac',
    event_name: 'classic_help_naa_alert_in_home_page_shown',
  },
  NAAArticlePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::naa-alert:::',
    e: 'ac',
    event_name: 'classic_help_naa_alert_in_article_page_shown',
  },
  NAASearchPage: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::naa-alert:::',
    e: 'ac',
    event_name: 'classic_help_naa_alert_in_search_page_shown',
  },
  NAATopicPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::naa-alert:::',
    e: 'ac',
    event_name: 'classic_help_naa_alert_in_topic_page_shown',
  },
  NAAIcfPage: {
    pageGroupName: 'main:help:smart::icf',
    pageName: 'main:help:smart::naa-alert:::',
    e: 'ac',
    event_name: 'classic_help_naa_alert_in_icftopic_page_shown',
  },

  // COVID BCP SUPPRESS CALLUS ALERT WINDOW
  covidBcpCallUsAlert: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::covid-bcp-callus-alert-window:::',
  },

  // Covid popup alerts
  contactUsAlertPopup: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::pop-up-alert:::',
    e: 'ac',
    event_name: 'classic_help_popup_alert_in_contactus_page_shown',
  },
  homeAlertPopup: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::pop-up-alert:::',
    e: 'ac',
    event_name: 'classic_help_popup_alert_in_home_page_shown',
  },
  searchAlertPopup: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::pop-up-alert:::',
    e: 'ac',
    event_name: 'classic_help_popup_alert_in_search_page_shown',
  },
  articleAlertPopup: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::pop-up-alert:::',
    e: 'ac',
    event_name: 'classic_help_popup_alert_in_article_page_shown',
  },
  topicAlertPopup: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::pop-up-alert:::',
    e: 'ac',
    event_name: 'classic_help_popup_alert_in_topic_page_shown',
  },
  ICFTopicAlertPopup: {
    pageGroupName: 'main:help:smart::icf-topic',
    pageName: 'main:help:smart::pop-up-alert:::',
    e: 'ac',
    event_name: 'classic_help_popup_alert_in_icftopic_page_shown',
  },
  ICFPageAlertPopup: {
    pageGroupName: 'main:help:smart::icf',
    pageName: 'main:help:smart::pop-up-alert:::',
    e: 'ac',
    event_name: 'classic_help_popup_alert_in_icfalert_page_shown',
  },

  // Covid popup alerts
  contactUsCriticalAlert: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::critical-alert:::',
    e: 'ac',
    event_name: 'classic_help_critical_alert_in_contact_page_shown',
  },
  homeCriticalAlert: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::critical-alert:::',
    e: 'ac',
    event_name: 'classic_help_critical_alert_in_home_page_shown',
  },
  searchCriticalAlert: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::critical-alert:::',
    e: 'ac',
    event_name: 'classic_help_critical_alert_in_search_page_shown',
  },
  articleCriticalAlert: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::critical-alert:::',
    e: 'ac',
    event_name: 'classic_help_critical_alert_in_article_page_shown',
  },
  topicCriticalAlert: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::critical-alert:::',
    e: 'ac',
    event_name: 'classic_help_critical_alert_in_topic_page_shown',
  },
  ICFTopicCriticalAlert: {
    pageGroupName: 'main:help:smart::icf-topic',
    pageName: 'main:help:smart::critical-alert:::',
    e: 'ac',
    event_name: 'classic_help_critical_alert_in_icftopic_page_shown',
  },
  ICFPageCriticalAlert: {
    pageGroupName: 'main:help:smart::icf',
    pageName: 'main:help:smart::critical-alert:::',
    e: 'ac',
    event_name: 'classic_help_critical_alert_in_icfarticle_page_shown',
  },

  // Refund Tracker
  refundsTrackerContactUs: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::refund-status-tracker:::',
    e: 'ac',
    event_name: 'classic_help_refund_status_tracker_in_contactus_page_shown',
  },
  refundsTrackerHome: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::refund-status-tracker:::',
    e: 'ac',
    event_name: 'classic_help_refund_status_tracker_in_home_page_shown',
  },
  refundsTrackerArticle: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::refund-status-tracker:::',
    e: 'ac',
    event_name: 'classic_help_refund_status_tracker_in_article_page_shown',
  },
  refundAlertContactUs: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::refund-status-alert:::',
    e: 'ac',
    event_name: 'classic_help_refund_status_alert_in_contactus_page_shown',
  },
  refundAlertSearch: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::refund-status-alert:::',
    e: 'ac',
    event_name: 'classic_help_refund_status_alert_in_search_page_shown',
  },
  // NNA
  nnaHomePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::nna-widget:::',
    e: 'ac',
    event_name: 'classic_help_naa_widget_in_home_page_shown',
  },
  nnaHomePageError: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::nna-widget-error:::',
    e: 'ac',
    event_name: 'classic_help_naa_widget_error_in_home_page',
  },
  // omniChannel
  updateContext: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::update-context:::',
  },
  updateContextSuccess: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::update-context-success:::',
    e: 'ac',
    event_name: 'classic_help_ocp_update_context_success',
  },
  updateContextFailure: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::update-context-failed:::',
    e: 'ac',
    event_name: 'classic_help_ocp_update_context_failed',
  },

  setContext: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::set-context:::',
  },
  setContextSuccess: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::set-context-success:::',
    e: 'ac',
    event_name: 'classic_help_ocp_set_context_success',
  },
  setContextFailure: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::set-context-failed:::',
    e: 'ac',
    event_name: 'classic_help_ocp_set_context_failed',
  },

  // Brexit
  complaintsPage: {
    pageGroupName: 'main:help:smart::complaints',
    pageName: 'main:help:smart::complaints-page:::',
    e: 'im',
    event_name: 'classic_help_complaints_page_displayed',
  },

  complaintsIntermediatePage: {
    pageGroupName: 'main:help:smart::complaints',
    pageName: 'main:help:smart::intermediate:::',
    e: 'im',
    event_name: 'classic_help_intermediate_page_in_complaints_page_displayed',
  },

  omniChannelPromptYes: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::update-context-prompt-clicked-yes:::',
  },

  omniChannelPromptNo: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::update-context-prompt-clicked-no:::',
  },

  omniChannelPromptYesFaqNotExist: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::update-context-prompt-clicked-yes-faq-doesnot-exist:::',
  },

  omniChannelPromptDisplayed: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::omni-channel-prompt-displayed:::',
    e: 'ac',
    event_name: 'classic_help_ocp_prompt_displayed',
  },

  omniChannelPromptNotDisplayed: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::omni-channel-prompt-not-displayed:::',
    e: 'ac',
    event_name: 'classic_help_ocp_prompt_not_displayed',
  },

  omniChannelUpdateContextNotFired: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::omni-channel-update-context-not-fired:::',
    e: 'ac',
    event_name: 'classic_help_ocp_update_context_not_fired',
  },

});

export const PageMapping = {
  'contact-us': 'contactUsPage',
  callus: 'callUsPage',
  email: 'emailPage',
  home: 'homePage',
  search: 'searchPage',
  article: 'articlePage',
  topic: 'topicPage',
  icf: 'ICFTopic',
  PAYPAL_HELP_GUIDE: 'ICFTopic',
};
